(() => {
  if (window.__sbSuperclubLandingBound) return;

  const root = document.querySelector('[data-superclub-root]');
  if (!root) return;

  window.__sbSuperclubLandingBound = true;
  document.documentElement.classList.add('superclub-page');

  const customerState = root.dataset.customerState === 'member' ? 'member' : 'guest';
  document.documentElement.classList.add(`superclub-page--${customerState}`);
  const device = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';

  function emit(action, details = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: action,
      customer_state: customerState,
      device,
      ...details,
    });
  }

  function buildDisclosure(text, className, controls) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `superclub-disclosure ${className}`;
    button.textContent = text;
    button.setAttribute('aria-expanded', 'false');
    if (controls) button.setAttribute('aria-controls', controls);
    return button;
  }

  function setupTierPanel() {
    const tierSection = document.querySelector('#rivo-vip-tiers');
    const tierContent = tierSection?.querySelector('.rivo-lp-content');
    const tierProgress = tierSection?.querySelector('.rivo-vip-tier-progress-container');
    const tierTable = tierSection?.querySelector('.rivo-vip-tier-container');
    if (!tierSection || !tierContent || !tierTable) return;

    tierSection.querySelector('.superclub-tier-toggle')?.remove();
    tierSection.removeAttribute('data-superclub-expanded');
    tierTable.removeAttribute('data-superclub-collapsible');
    tierTable.removeAttribute('aria-hidden');
    tierTable.inert = false;

    tierTable.tabIndex = 0;
    tierTable.setAttribute('role', 'region');
    tierTable.setAttribute('aria-label', 'SuperClub tier benefits table. Swipe horizontally to compare tiers.');

    function setupTierTableMeta() {
      if (tierSection.querySelector('[data-superclub-tier-table-meta]')) return;

      const meta = document.createElement('div');
      meta.className = 'superclub-tier-table-meta';
      meta.dataset.superclubTierTableMeta = 'true';
      meta.innerHTML = '<span>Benefits by tier</span><span class="superclub-tier-table-hint">Swipe to compare</span>';
      tierTable.before(meta);
    }

    if (tierSection.querySelector('[data-superclub-tier-panel]')) {
      setupTierTableMeta();
      return;
    }

    const panel = document.createElement('section');
    panel.className = `superclub-member-tier-panel superclub-member-tier-panel--${customerState}`;
    panel.dataset.superclubTierPanel = 'true';
    panel.setAttribute(
      'aria-label',
      customerState === 'member' ? 'Your tier status and benefits' : 'SuperClub tiers and benefits'
    );
    tierTable.before(panel);
    if (customerState === 'member' && tierProgress) panel.append(tierProgress);
    panel.append(tierTable);
    const heading = document.createElement('h2');
    heading.className = 'superclub-benefits-title';
    heading.textContent = customerState === 'member' ? 'Your tier & benefits' : 'Compare SuperClub benefits';
    panel.prepend(heading);
    const note = root.querySelector('[data-superclub-benefit-note]');
    if (note) panel.append(note.content.cloneNode(true));
    setupTierTableMeta();
  }

  function setupFaqDisclosure() {
    const faqWrapper = document.querySelector('.rivo-faqs-wrapper');
    if (!faqWrapper || faqWrapper.dataset.superclubReady) return;

    faqWrapper.dataset.superclubReady = 'true';
    faqWrapper.dataset.superclubExpanded = 'false';
    faqWrapper.id ||= 'superclub-faq-list';

    const button = buildDisclosure('View all FAQs', 'superclub-faq-toggle', faqWrapper.id);
    button.addEventListener('click', () => {
      const expanded = faqWrapper.dataset.superclubExpanded === 'true';
      faqWrapper.dataset.superclubExpanded = String(!expanded);
      button.setAttribute('aria-expanded', String(!expanded));
      button.textContent = expanded ? 'View all FAQs' : 'Show fewer FAQs';
      emit('faq_view_all', { expanded: !expanded });
    });
    faqWrapper.after(button);
  }

  function setupMemberSummary() {
    if (customerState !== 'member') return;

    const explainer = document.querySelector('#rivo-lp-explainer');
    const summary = root.querySelector('[data-superclub-member-summary]');
    const pointsSource = explainer?.querySelector('.rivo-lp-section-title strong');
    const points = Number.parseInt((pointsSource?.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (!summary || !Number.isFinite(points)) return;

    const pointsText = points.toLocaleString('en-US');
    const valueText = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(points / 100);
    const pointsTarget = summary.querySelector('[data-superclub-points]');
    const valueTarget = summary.querySelector('[data-superclub-value]');
    const tierTarget = summary.querySelector('[data-superclub-tier]');
    const currentTier = document
      .querySelector('#rivo-vip-tiers .rivo-lp-section-subtitle')
      ?.textContent.match(/on the\s+(.+?)\s+tier/i)?.[1]
      ?.trim();

    if (pointsTarget.textContent !== pointsText) pointsTarget.textContent = pointsText;
    if (valueTarget.textContent !== valueText) valueTarget.textContent = valueText;
    if (currentTier && tierTarget.textContent !== currentTier) tierTarget.textContent = currentTier;
  }

  function setupDynamicSections() {
    if (document.querySelector('iframe[src*="shopifycloud/preview-bar"], #PBarNextFrame')) {
      document.documentElement.classList.add('superclub-page--draft-preview');
    }
    setupTierPanel();
    setupMemberSummary();
    setupFaqDisclosure();
  }

  document.addEventListener('click', (event) => {
    const tracked = event.target.closest('[data-superclub-event]');
    if (tracked) emit(tracked.dataset.superclubEvent);

    const faqQuestion = event.target.closest('.rivo-faq-question');
    if (faqQuestion) {
      const items = Array.from(document.querySelectorAll('.rivo-faq-question'));
      emit('faq_open', { faq_index: items.indexOf(faqQuestion) + 1 });
    }
  });

  emit('superclub_view');
  setupDynamicSections();

  const observer = new MutationObserver(setupDynamicSections);
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 30000);
})();
